export default __webpack_public_path__ + "static/sports_small-f04f1703080091e61b6fc3177e6b3934.png";